/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-17 15:40:05
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-04-28 10:08:26
 * @FilePath: /seller-station-client/src/hooks/useRateFormatMoney.ts
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { Decimal } from 'decimal.js';
import { formatMoney } from '@/utils/biz';
import { rateInfo } from '@/atom/rate';
import { ChargeServiceRate } from '@/const/baseEnum';

/** 根据汇率格式化金额，有美元千分位分隔符 TODO-纯函数抽离 */
export const useRateFormatMoney = (isUs = false) => {
	const floatingRate = rateInfo()?.floatingRate ?? 1;
	return (zhPrice?: number): string => {
		if (zhPrice !== 0 && (!zhPrice || isNaN(Number(zhPrice)))) return '';
		if (
			floatingRate !== 0 &&
			(!floatingRate || isNaN(Number(floatingRate)))
		)
			return '';
		const foreignPrice = isUs
			? zhPrice * floatingRate
			: zhPrice / floatingRate;
		return formatMoney(foreignPrice.toFixed(2));
	};
};

/** 根据汇率格式化金额，有美元千分位分隔符 TODO-纯函数抽离 */
export const useRateFormatMoneyFloor = (isUs = false) => {
	const floatingRate = rateInfo()?.floatingRate ?? 1;
	return (zhPrice?: number): string => {
		if (zhPrice !== 0 && (!zhPrice || isNaN(Number(zhPrice)))) return '';
		if (
			floatingRate !== 0 &&
			(!floatingRate || isNaN(Number(floatingRate)))
		)
			return '';
		const nzhPrice = new Decimal(zhPrice);
		const nfloatingRate = new Decimal(floatingRate);
		const foreignPrice = isUs
			? nzhPrice.times(nfloatingRate)
			: nzhPrice.div(floatingRate);

		return String(
			foreignPrice ? Math.floor(Number(foreignPrice) * 100) / 100 : 0
		);
	};
};

/** 根据中文价格获取汇率转换后的 整数和小数部分 */
export const useGetFormatAfterNumberList = (isUs = false) => {
	const format = useRateFormatMoney(isUs);
	return (zhPrice?: number): [string, string] => {
		const foreignPrice = format(zhPrice);
		if (!foreignPrice.includes('.')) {
			return [foreignPrice, '00'];
		}
		const splitList = foreignPrice.split('.');
		const lastPrice = splitList[1] ?? '00';
		return [
			splitList[0],
			lastPrice.length === 2 ? lastPrice : lastPrice + '0'
		];
	};
};

/** 获取价格的两位数字 */
export const getPriceTwoList = (price?: number) => {
	if (price !== 0 && (!price || isNaN(Number(price)))) return ['', ''];
	const splitList = String(price).split('.');
	const lastPrice = splitList[1] ?? '00';
	return [splitList[0], lastPrice.length === 2 ? lastPrice : lastPrice + '0'];
};

/** 美元固定 */
export const calRateToUs = (price) => {
	const final = price * ChargeServiceRate - 0.3;
	return final > 0 ? final : 0;
};
